import {
  UNITS,
  MILES_TO_KILOMETRES,
  KILOMETRES_TO_MILES,
  FEET_TO_METRES,
} from './const.js'

export const createVehicleData = attack => {
  let data = []
  for (const [key, value] of Object.entries(attack.all_vehicle_data)) {
    data.push(
      createVehicleDataItem({
        vehicle: key,
        end_speed: value['end_speed'],
        units: attack.units,
      })
    )
  }
  return data
}

export const createVehicleDataItem = v => {
  let energy = ''
  let mass = +vehicleTypes
    .find(item => item.vehicle === v.vehicle)
    .mass.split(' ')[0]
  try {
    energy = v.end_speed
      ? kineticEnergy(v.end_speed, mass, v.units).toFixedDown(2)
      : ''
  } catch (error) {
    console.log(
      `Could not calculate energy. Is the vehicle type valid?: ${error.stack}`
    )
  }

  return {
    end_speed: v.end_speed ? v.end_speed.toFixedDown(2) : '',
    energy,
    vehicle: v.vehicle,
    mass,
  }
}

export const convertToMetric = attack => {
  return {
    ...attack,
    start_speed:
      attack.units.speedUnits === 'mph'
        ? MILES_TO_KILOMETRES * attack.start_speed
        : attack.start_speed,
    path_length:
      attack.units.distanceUnits === 'ft'
        ? FEET_TO_METRES * attack.path_length
        : attack.path_length,
  }
}

export const convertBack = (original, attack) => {
  return {
    ...attack,
    start_speed: original.start_speed,
    path_length: original.path_length,
  }
}

export const convertEndSpeedBack = (original, end_speed) => {
  return original.units.speedUnits === 'mph'
    ? KILOMETRES_TO_MILES * end_speed
    : end_speed
}

export const getMassUnits = () => {
  return Object.keys(UNITS).map(unit => {
    return UNITS[unit].massUnits
  })
}

export const getDistanceUnits = () => {
  return Object.keys(UNITS).map(unit => {
    return UNITS[unit].distanceUnits
  })
}

export const getSpeedUnits = () => {
  return Object.keys(UNITS).map(unit => {
    return UNITS[unit].speedUnits
  })
}

export const userLocation = async () => {
  return new Promise((ok, fail) => {
    try {
      console.log('userLocation')
      let location = null
      // eslint-disable-next-line no-undef
      if ('geolocation' in navigator) {
        // eslint-disable-next-line no-undef
        navigator.geolocation.getCurrentPosition(function (position) {
          location = [position.coords.longitude, position.coords.latitude]
          console.log('userLocation found: ', location)
          ok(location)
        })
      } else {
        fail('userLocation is not available')
      }
    } catch (e) {
      throw `userLocation error: ${e}`
    }
  })
}

export const kineticEnergy = (velocity, mass, units) => {
  const metricVelocity =
    units.speedUnits === 'mph' ? MILES_TO_KILOMETRES * velocity : velocity
  //todo when we show lbs in the vehicle dropdown
  //const metricMass = units.massUnits === 'lbs' ? LBS_TO_KG * mass : mass
  return (0.5 * mass * (metricVelocity / 3.6) ** 2) / 1000
}

Number.prototype.toFixedDown = function (digits) {
  var re = new RegExp('(\\d+\\.\\d{' + digits + '})(\\d)'),
    m = this.toString().match(re)
  return m ? parseFloat(m[1]) : this.valueOf()
}

export const vehicleTypes = [
  {
    vehicle: 'C (1100)',
    mass: '1100 kg',
    standard: 'ASTM & F2656',
    cornerData: 'UFC_C_1100_Corner',
    straightData: 'UFC_C_1100_Straight',
  },
  {
    vehicle: 'P (2300)',
    mass: '2300 kg',
    standard: 'ASTM & F2656',
    cornerData: 'UFC_P_2300_Corner',
    straightData: 'UFC_P_2300_Straight',
  },
  {
    vehicle: 'M (6800)',
    mass: '6800 kg',
    standard: 'ASTM & F2656',
    cornerData: 'UFC_M_6800_Corner',
    straightData: 'UFC_M_6800_Straight',
  },
  {
    vehicle: 'H (29500)',
    mass: '29500 kg',
    standard: 'ASTM & F2656',
    cornerData: 'UFC_H_29500_Corner',
    straightData: 'UFC_H_29500_Straight',
  },
  {
    vehicle: 'M1',
    mass: '1500 kg',
    standard: 'IWA-14 & PAS 68',
    cornerData: 'CPNI_1_5_T_Corner',
    straightData: 'CPNI_1_5_T_Straight',
  },
  {
    vehicle: 'N1G',
    mass: '2500 kg',
    standard: 'IWA-14 & PAS 68',
    cornerData: 'CPNI_2_5_T_Corner',
    straightData: 'CPNI_2_5_T_Straight',
  },
  {
    vehicle: 'N1',
    mass: '3500 kg',
    standard: 'IWA-14 & PAS 68',
    cornerData: 'CPNI_3_5_T_Corner',
    straightData: 'CPNI_3_5_T_Straight',
  },
  {
    vehicle: 'N2A',
    mass: '7200 kg',
    standard: 'IWA-14',
    cornerData: 'CPNI_7_5_T_N2_Corner',
    straightData: 'CPNI_7_5_T_N2_Straight',
  },
  {
    vehicle: 'N2',
    mass: '7500 kg',
    standard: 'PAS 68',
    cornerData: 'CPNI_7_5_T_N2_Corner',
    straightData: 'CPNI_7_5_T_N2_Straight',
  },
  {
    vehicle: 'N3 2 Axle',
    mass: '18000 kg',
    standard: 'IWA-14 & PAS 68',
    cornerData: 'CPNI_18_T_N3_Corner',
    straightData: 'CPNI_18_T_N3_Straight',
  },
  {
    vehicle: 'N3 4 Axle',
    mass: '30000 kg',
    standard: 'IWA-14 & PAS 68',
    cornerData: 'CPNI_30_T_Corner',
    straightData: 'CPNI_30_T_Straight',
  },
]

export const mapStyle = mapChoice => {
  let style
  if (mapChoice === 'light-v9') {
    style = 'mapbox://styles/mapbox/light-v9'
  }
  if (mapChoice === 'dark-v9') {
    style = 'mapbox://styles/mapbox/dark-v9'
  }
  if (mapChoice === 'streets-v9') {
    style = 'mapbox://styles/mapbox/streets-v9'
  }
  if (mapChoice === 'outdoors-v9') {
    style = 'mapbox://styles/mapbox/outdoors-v9'
  } else if (mapChoice === 'satellite-v9') {
    style = 'mapbox://styles/mapbox/satellite-v9'
  }
  return style
}

export const checkNullorEmptyObj = obj =>
  !obj || (Object.keys(obj).length === 0 && obj.constructor === Object)
